import {date} from './Date/en'

export const general = {
  ...date,
}
